import React from 'react';

const TermsAndConditions: React.FC<any> = ({ data }) => {
    return (
        <div className="container mx-auto py-8 px-4 text-white mt-7 md:mt-[156px]">
            <h1 className="text-[24px] md:text-[32px] font-bold text-[#FFFFFFBF]">Terms & Conditions</h1>
            <p className='text-sm md:text-[16px] text-[#FFFFFFBF] font-medium leading-[42px]'>By accepting these Terms & Conditions, you enter a contract with GoodKarmaBetting.</p>
            <p className='text-sm md:text-[16px] text-[#FFFFFFBF] font-medium leading-[42px] mb-5'>You also agree that we may send you emails and text messages, which you may opt out of at any time.</p>
            {data.map((item: any, index: number) => (
                <div key={index} className="mb-4">
                    {item.type === 'title' && (
                        <h2 className="text-[#FFFFFFBF] text-[14px] md:text-[16px] font-bold">{item.content}</h2>
                    )}
                    {item.type === 'content' && (
                        <p className="text-[#FFFFFFBF] text-[14px] md:text-[16px] font-medium">{item.content}</p>
                    )}
                    {item.type === 'list' && (
                        <ul className={item.style === 'none' ? 'pl-5' : 'list-disc pl-5'}>
                            {item.items?.map((listItem: any, listIndex: number) => (
                                <li key={listIndex} className="text-base text-[#FFFFFFBF]">{listItem}</li>
                            ))}
                        </ul>
                    )}
                </div>
            ))}
        </div>
    );
};

export default TermsAndConditions;
